<div class="flex grow items-center justify-center align-middle">
    @if (!small) {
        <svg class="size-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="svgIconSvg" />
        </svg>
    } @else {
        <svg class="size-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="svgIconSvg" />
        </svg>
    }
</div>